import QuranProgramsWithUsersModel from '../Apis/QuranProgramsWithUsers'
import Controller from './Controller'

export default class QuranProgramsWithUsersController extends Controller {
  constructor() {
    super(new QuranProgramsWithUsersModel())
  }

}
